import React from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

import Strip from '../Strip';

import BaseSkeleton from '../SkeletonUI/SkeletonComponents/BaseSkeleton';

import Colors from '../../theme/colors';

import { CardProps } from './Card.types';

const useStyles = makeStyles({
  root: {
    background: Colors.light,
    borderRadius: '8px',
    boxShadow: 'none'
  },

  vertical: {
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center'
  },

  variantVertical: {
    width: '155px'
  },

  variantSquare: {
    display: 'block',
    height: '305px',
    minWidth: '325px'
  },

  variantInfo: {
    height: '120px',
    overflow: 'hidden',
    width: '120px'
  },

  rootWithStrip: {
    borderRadius: '8px 8px 0px 0px'
  },

  rootWithStripTop: {
    borderRadius: '0px 0px 8px 8px'
  },

  strip: {
    borderRadius: '0px 0px 8px 8px'
  },

  stripTop: {
    borderRadius: '8px 8px 0px 0px'
  }
});

const Card: React.FC<CardProps> = ({
  variant,
  children,
  className,
  strip,
  stripPosition,
  onClick,
  cardClassName,
  removeCardShadow,
  borderClass,
  loading,
  ...others
}) => {
  const classes = useStyles();
  let cardClass = clsx(
    classes.root,
    strip
      ? stripPosition == 'top'
        ? classes.rootWithStripTop
        : classes.rootWithStrip
      : ''
  );
  switch (variant) {
    case 'vertical':
      cardClass = clsx(classes.root, classes.variantVertical, classes.vertical);
      break;
    case 'square':
      cardClass = clsx(classes.root, classes.variantSquare, classes.vertical);
      break;
    case 'info':
      cardClass = clsx(classes.root, classes.variantInfo);
      break;
    default:
      break;
  }

  if (strip) {
    if (loading) {
      return (
        <div
          onClick={onClick}
          className={clsx(
            `card-shadow ${borderClass ? borderClass : 'br2'}`,
            strip && cardClassName
          )}
          {...others}
        >
          {strip && variant == 'default' && stripPosition == 'top' && (
            <Strip className={classes.stripTop} {...strip} loading={loading} />
          )}
          <div
            className={clsx(
              cardClass,
              'flex border-box overflow-hidden',
              className,
              !strip && cardClassName
            )}
          >
            <BaseSkeleton className="mb2 ml4" height={40} />
          </div>
          {strip && variant == 'default' && stripPosition == 'bottom' && (
            <Strip className={classes.strip} {...strip} loading={loading} />
          )}
        </div>
      );
    }
    return (
      <div
        onClick={onClick}
        className={clsx(
          `card-shadow ${borderClass ? borderClass : 'br2'}`,
          strip && cardClassName
        )}
        {...others}
      >
        {strip && variant == 'default' && stripPosition == 'top' && (
          <Strip className={classes.stripTop} {...strip} />
        )}
        <div
          className={clsx(
            cardClass,
            'flex border-box overflow-hidden',
            className,
            !strip && cardClassName
          )}
        >
          {children}
        </div>
        {strip && variant == 'default' && stripPosition == 'bottom' && (
          <Strip className={classes.strip} {...strip} />
        )}
      </div>
    );
  }

  return (
    <div
      onClick={onClick}
      className={clsx(
        cardClass,
        `flex border-box overflow-hidden ${borderClass ? borderClass : 'br2'} ${
          removeCardShadow ? '' : 'card-shadow'
        }`,
        className,
        cardClassName
      )}
      {...others}
    >
      {children}
    </div>
  );
};

Card.defaultProps = {
  variant: 'default',
  children: <></>,
  className: 'p4',
  stripPosition: 'bottom',
  onClick: () => {},
  cardClassName: '',
  removeCardShadow: false,
  loading: false
};

export default Card;
export { CardProps };
